export default __webpack_public_path__ + "static/media/wyndham1.8e4fdf2a.png";